export default {
  LIKELY: 'LIKELY',
  UNLIKELY: 'UNLIKELY',
  VERY_LIKELY: 'VERY_LIKELY',
}
